import { render, staticRenderFns } from "./nice-input.vue?vue&type=template&id=2291c225&scoped=true"
import script from "./nice-input.vue?vue&type=script&lang=js"
export * from "./nice-input.vue?vue&type=script&lang=js"
import style0 from "./nice-input.vue?vue&type=style&index=0&id=2291c225&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2291c225",
  null
  
)

export default component.exports